//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        name: {
            type: String,
            default: 'list'
        },
        initialitems: {
            default: [],
            validator: function validator(value) {
                return Array.isArray(value) && value.every(function (v) {
                    return typeof v === 'string' || v instanceof String;
                });
            }
        }
    },
    mounted: function mounted() {
        if (!this.name.endsWith('[]')) {
            this.name += '[]';
        }
    },
    data: function data() {
        return {
            newText: '',
            items: this.initialitems.slice()
        };
    },

    methods: {
        addItem: function addItem() {
            var text = this.newText.trim();
            if (text === '') {
                return;
            }

            this.items.push(text);
            this.newText = '';
        },
        removeItem: function removeItem(index) {
            if (index > -1) {
                this.items.splice(index, 1);
            }
        },
        moveDown: function moveDown(index) {
            if (index - 1 >= this.items.length || index < 0) {
                return;
            }
            var aboveIndex = this.items[index + 1];
            this.items[index + 1] = this.items[index];
            this.items[index] = aboveIndex;
            this.items = this.items.slice();
        },
        moveUp: function moveUp(index) {
            if (index >= this.items.length || index - 1 < 0) {
                return;
            }
            var belowIndex = this.items[index - 1];
            this.items[index - 1] = this.items[index];
            this.items[index] = belowIndex;
            this.items = this.items.slice();
        }
    },
    computed: {}
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/ItemList.vue
// module id = 41
// module chunks = 0